import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SpickerIcon from "../../assets/Icons/qa.svg";
import WalletIcon from "../../assets/Icons/Wallet-menu.svg";
import BellIcon from "../../assets/Icons/bell_svgrepo.com.svg";
import ReloadIcon from "../../assets/Icons/reload.svg";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/Appan Courier Logo.png";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { setBalance } from "../store/balance/balanceSlice";
import CustomAlert from "../../helpers/CustomAlert";
import WalletBalanceModal from "./WalletBalanceModal";

const Header = () => {
  const balance = useSelector((state) => state.balance.balance);
  const loggedInUserName = sessionStorage.getItem("username");
  const dispatch = useDispatch();
  const location = useLocation();

  const [showWalletDetails, setShowWalletDetails] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showWalletBalance, setShowWalletBalance] = useState(false);
  const [walletDetail, setWalletDetails] = useState([]);
  const [walletTitle, setWalletTitle] = useState("");

  useEffect(() => {
    setShowWalletDetails(true);
  }, [location.pathname]);

  const fetchWalletDetails = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    setLoading(true);

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
          setLoading(false);
        } else {
          setLoading(false);
          CustomAlert({
            title: "Data Fetch Error",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching SMS overview data", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className={`!bg-white backdrop-blur-[10px] shadow-custom3 py-2 px-[30px] flex items-center justify-between fixed top-0 w-[99%] z-20 rounded-b-2xl h-[67px]`}
    >
      {/* Mobile View (<= 430px) */}
      <div className="flex h-[70px] mr-[10px] items-center justify-between w-full md:hidden">
        {/* Center - Logo */}
        <img src={SpickerIcon} alt="Appan Dukan Logo" className="h-[50px]" />

        {/* Right - Notification Bell & User Profile */}
        <div className="flex items-center gap-3">
          <img src={SpickerIcon} alt="Notification Icon" className="w-6 h-7" />
        </div>
      </div>

      {/* Laptop/Desktop View (>= 430px) */}
      <div className="hidden md:flex items-center justify-between w-full">
        <div className="flex items-center justify-start gap-16 w-[75%]">
          <img src={logo} alt="Appan Dukan Logo" className="h-[60px]" />
          {/* <div className="flex items-center justify-start gap-6 w-[100%]">
            <img src={SpickerIcon} alt="spickericon" className="h-[45px]" />
            <div className="bg-[#ECF5FF] border-l-[2px] border-secondary w-[70%] overflow-hidden">
              <p className="animate-scroll whitespace-nowrap w-[427px] text-sm font-normal text-text">
                This Is a Sample Scrolling text that has scrolls texts to left
              </p>
            </div>
          </div> */}
        </div>

        {/* Icons and Text */}
        <div className="flex items-center bg-[#f0f8ff] px-[10px] py-[5px] justify-end gap-4 relative border-[2px] w-fit ml-auto">
          {/* animation Balance */}
          {/* <div 
          className="flex items-center animate-float cursor-pointer"
          onClick={() => {
                setShowWalletBalance(true);
                setWalletDetails(balance?.mainBalanceAmountList);
                setWalletTitle("Main Balance Amount");
              }}>
            <i
              className="fas fa-wallet"
              style={{ color: "#FF702B", fontSize: "16px" }}
              onClick={() => setShowWalletDetails(!showWalletDetails)}
            ></i>
            <b className="text-primary text-[16px] ml-1"
            >
              {balance?.mainBalanceAmount?.length > 9
                ? balance?.mainBalanceAmount?.slice(0, 9) + "..."
                : balance?.mainBalanceAmount || 0}
            </b>
          </div> */}

          <div
            className={`flex items-center gap-2 transform transition-all duration-500 ease-in-out overflow-hidden ${
              showWalletDetails
                ? "translate-x-0 opacity-100 w-fit"
                : "translate-x-[10%] opacity-0 w-fit"
            }`}
          >
            {/* Main Balance Amount */}
            <div
              className="pr-4 border-r border-dashed border-[#495057] flex flex-col items-start gap-0 cursor-pointer"
              onClick={() => {
                setShowWalletBalance(true);
                setWalletDetails(balance?.mainBalanceAmountList);
                setWalletTitle("Main Balance Amount");
              }}
            >
              <p className="text-[#495057] text-sm font-semibold">
                Wallet Balance
              </p>
              {/* <p className="text-primary font-medium text-[18px]">
                ₹ {""}
                {balance?.wallet?.balance?.length > 9
                  ? balance?.wallet?.balance?.slice(0, 9) + "..."
                  : balance?.wallet?.balance || 0}
              </p> */}
              <p className="text-primary font-medium text-[18px] whitespace-nowrap">
                ₹{" "}
                {balance?.wallet?.balance
                  ? Number(balance.wallet.balance).toFixed(2)
                  : "0.00"}
              </p>
            </div>
            <div
              className="w-7 h-6 !bg-[#ff702b] rounded-[4px] flex items-center justify-center cursor-pointer ml-2"
              onClick={() => fetchWalletDetails()}
            >
              <img
                src={ReloadIcon}
                alt="ReloadIcon"
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </div>
          </div>
          <img
            src={WalletIcon}
            alt="Wallet"
            className="w-6 h-6 cursor-pointer flex-shrink-0"
            onClick={() => setShowWalletDetails(!showWalletDetails)}
          />
          <img src={BellIcon} alt="Bell" className="w-6 h-6 flex-shrink-0" />
        </div>
      </div>
      <WalletBalanceModal
        show={showWalletBalance}
        handleClose={() => setShowWalletBalance(false)}
        walletDetail={walletDetail}
        walletTitle={walletTitle}
      />
    </div>
  );
};

export default Header;
